module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shopping-bar flex-box"
  }, [_c('div', {
    staticClass: "icon iconfont",
    class: [("icon-" + _vm.icon)]
  }), _vm._v(" "), _c('div', {
    staticClass: "flex-item-1 tl shopping-info"
  }, [_c('div', {
    staticClass: "bar-price font-strong"
  }, [_c('span', {
    staticClass: "font-sm color-highlight"
  }, [_vm._v(_vm._s(_vm.unit))]), _vm._v(" "), _c('span', {
    staticClass: "font-md color-highlight"
  }, [_vm._v(_vm._s(_vm.price))])]), _vm._v(" "), _c('div', {
    staticClass: "font-light font-sm bar-total"
  }, [_vm._v("共计" + _vm._s(_vm.total) + "件")])]), _vm._v(" "), _c('div', {
    staticClass: "flex-item"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    on: {
      "click": _vm.handleClick
    }
  }, [_vm._v("\n      " + _vm._s(_vm.btnText) + "\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5ad0c101!./~/vue-loader/lib/selector.js?type=template&index=0!./src/other/shopping-bar/shopping-bar.vue
// module id = 253
// module chunks = 21